<article class="container-fluid">

    <div class="configure--header mb-3">
        <div class="configure_header--left">
            <h1>Prioritization</h1>
            <p class="prioritization--header-description">
                When using timers in order to prioritize work appropriately, we need to know the importance in which to place the different types of timers and tasks.
            </p>
        </div>
    </div>

    <div *ngIf="loading" class="loading"></div>
    <div class="prioritization--container">
        <!-- Reorder the priority -->
        <div class="prioritization--reorder">
            <h3>Use arrows to reorder the timer priority</h3>

            <div class="mt-3">
                <ng-container *ngFor="let pCard of currentPrioritizationCards; let i = index">
                    <div class="d-flex mb-2 prioritization--row">
                        <h3 class="prioritization--row-index">{{i + 1}}</h3>
                        <div class="prioritization--card card" [ngClass]="'prioritization--card-' + pCard.Priority">
                            <div class="prioritization--card-inner">
                                <h3 class="prioritization--card-name">{{ pCard.Name }}</h3>
                                <div class="prioritization--card-arrow">
                                    <aurora-icon-button [disabled]="!isValidDownState(i)" icon="arrow-down" variant="ghost" size="large" aria-label="Move down" (click)="moveDown(pCard)"></aurora-icon-button>
                                    <aurora-icon-button [disabled]="!isValidUpState(i)" icon="arrow-up" variant="ghost" size="large" aria-label="Move up" (click)="moveUp(pCard)"></aurora-icon-button>
                                </div>                              
                            </div>                        
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Set the Imminent time -->
        <div class="prioritization--time">
            <h3>Set the default amount of time you would like timers to switch from Pending to Imminent</h3>

            <kendo-grid class="mt-3" [data]="imminentList">
                <kendo-grid-column title="Type" field="Name"></kendo-grid-column>
                <kendo-grid-column title="Amount of Time">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div class="d-flex">
                            <input name="imminentValue" type="number" class="form-control form-control-xs" [(ngModel)]="dataItem.Amount"
                                (ngModelChange)="imminentAmountChanged(dataItem)"/>
                            <select name="imminentUnit" class="form-select form-control ms-2" [(ngModel)]="dataItem.Units"
                                (ngModelChange)="imminentUnitsChanged(dataItem)">
                                <option [ngValue]="'business hours'">Business Hour(s)</option>
                                <option [ngValue]="'business days'">Business Day(s)</option>
                                <option [ngValue]="'calendar days'">Calendar Day(s)</option>
                            </select>
                        </div>                    
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</article>

<!-- Footer -->
<div class="configure--footer d-flex justify-content-between">
    <div>
        <sm-date-by *ngIf="(lastUpdatedBy | async)?.Name" [LeftText]="'Last Updated: '" [ShowUserName]="true" 
            [User]="lastUpdatedBy | async" [Date]="lastUpdated"></sm-date-by>
    </div>
    
    <div>
    <aurora-button id="PrioritizationSaveButton" (click)="confirmSave()" [disabled]="!canSave()" variant="primary" class="me-2">Update Prioritization</aurora-button>
    <aurora-button (click)="onCancel()" variant="tertiary">Cancel</aurora-button>
    </div>
</div>